import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app/App';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import './locales/i18n';
import './index.css';
import Auth, { authLoader } from './components/auth/Auth';
import Login from './components/login/Login';
import Logout from './components/logout/Logout';

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: "auth",
                element: <Auth />,
                loader: authLoader,
            },
            {
                path: "login",
                element: <Login />,
            },
            {
                path: "logout",
                element: <Logout />,
            },
        ]
    },
]);


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
